package com.yourssu.lms_api_guide

fun main() {
    BootstrapDashboard().start()
}
